import request from '../utils/request.js'

/**
 * 购物车商品列表
 * **/
export function getCartList(url) {
  return request({
    url: url,
    method: 'get'
  })
}

/**
 * 查看购物车商品数量
 * **/
export function getCartGoodsCount(data) {
  return request({
    url: '/rest/cart/goods/count',
    method: 'get',
    data
  })
}

/**
 * 修改购物车中商品数量接口
 * **/
export function changeCartGoodNum(data) {
  return request({
    url: '/rest/cart/incre',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:data
  })
}


/**
 * 去结算
 * **/
export function orderPre(data) {
  return request({
    url: '/rest/cart/order/pre',
    method: 'post',
    data
  })
}


/**
 * 保存电子祝福卡内容
 * **/
export function sendBless(data) {
  return request({
    url: '/rest/cart/bless',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data:data
  })
}
/**
 * 兑换优惠券
 * **/
export function exchangeCoupon(data) {
  return request({
    url: '/order/couponBind',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/shopping-cart.js